export default __webpack_public_path__ + "assets/logos/48c5d243f4e6bc1759aa846f342438b7.png";